/**
 * 面包屑(首页 / … / 当前)。带 to 的段为链接,末段纯文本。
 */
import { Link } from 'react-router-dom';

export interface Crumb {
  label: string;
  to?: string;
}

export function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <div className="sm muted mb-6">
      {items.map((c, i) => (
        <span key={`${c.label}-${i}`}>
          {i > 0 ? ' / ' : ''}
          {c.to ? (
            <Link to={c.to} style={{ color: 'inherit' }}>
              {c.label}
            </Link>
          ) : (
            c.label
          )}
        </span>
      ))}
    </div>
  );
}
